import { createDomain, sample } from 'effector'
import { AxiosErrorType, ThumbType } from '~/shared/api'
import { mapJsonApiMessageErrors } from '~/shared/lib/mapMessageErrors'
import { snackbarEnqueued } from '~/shared/lib/notifications'

const domain = createDomain('ui.form.pickImages')

export const saveImagesFx = domain.createEffect<
  {
    photo: Blob
    fieldName: string
    fnUpload: (photo: Blob) => Promise<ThumbType>
  },
  { thumb: ThumbType; fieldName: string },
  AxiosErrorType
>({
  async handler({ photo, fieldName, fnUpload }) {
    const thumb = await fnUpload(photo)

    return { thumb, fieldName }
  },
})

sample({
  clock: saveImagesFx.failData,
  filter: (e) => e?.response?.status === 413,
  fn() {
    return {
      message: 'Превышен максимальный размер фотографии 10 Мб.',
      variant: 'danger' as const,
    }
  },
  target: snackbarEnqueued,
})

sample({
  clock: saveImagesFx.failData,
  filter: (e) => e?.response?.status !== 413,
  fn(e) {
    return {
      message: mapJsonApiMessageErrors(e),
      variant: 'danger' as const,
    }
  },
  target: [snackbarEnqueued],
})

export const $savingImagesCount = domain
  .createStore<Record<string, number> | null>(null)
  .on(saveImagesFx, (state, { fieldName }) => ({
    ...state,
    [fieldName]: (state?.[fieldName] || 0) + 1,
  }))
  .on(
    [saveImagesFx.done, saveImagesFx.fail],
    (state, { params: { fieldName } }) => ({
      ...state,
      [fieldName]: state?.[fieldName] ? state?.[fieldName] - 1 : 0,
    }),
  )
